"use client";
import * as React from "react";
const SvgSuccessRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M5.83 11.43 2.96 8.56a.8.8 0 1 1 1.13-1.13l2.31 2.3 5.5-5.5a.8.8 0 1 1 1.13 1.13l-6.07 6.07a.8.8 0 0 1-1.13 0" }));
export {
  SvgSuccessRound as default
};
